import axios from 'axios'
const donem = async () => {
    let response;
    var config = {
        method: 'get',
        url: process.env.REACT_APP_API_URL + '/api/v1/donem/',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            response = err
        });
    return response;
};

const donemCreate = async (data) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_API_URL + '/api/v1/donem/create',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
        data : data
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            response = err
        });
    return response;
};

const donemUpdate = async (id,data) => {
    let response;
    var config = {
        method: 'put',
        url: process.env.REACT_APP_API_URL + '/api/v1/donem/'+id,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
        data : data
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            response = err
        });
    return response;
};

const donemAktif = async () => {
    let response;
    var config = {
        method: 'get',
        url: process.env.REACT_APP_API_URL + '/api/v1/donem/active',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            response = err
        });
    return response;
};



export {
    donem,
    donemCreate,
    donemUpdate,
    donemAktif
};